import { render, staticRenderFns } from "./FactorListEdit.vue?vue&type=template&id=1496e651&"
import script from "./FactorListEdit.vue?vue&type=script&lang=js&"
export * from "./FactorListEdit.vue?vue&type=script&lang=js&"
import style0 from "./FactorListEdit.vue?vue&type=style&index=0&id=1496e651&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports